import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import { PageVisibilityServiceImpl } from 'src/services/PageVisibilityService/impl';
import type { ReactBindings } from 'src/types/bindings';

export const pageVisibilityModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('PageVisibilityService')
        .to(PageVisibilityServiceImpl)
        .inSingletonScope()
        .onDeactivation((service) => service[Symbol.dispose]());
});
